import { render } from "./LegDetail.vue?vue&type=template&id=0e9af069"
import script from "./LegDetail.vue?vue&type=script&lang=js"
export * from "./LegDetail.vue?vue&type=script&lang=js"

import "./LegDetail.vue?vue&type=style&index=0&id=0e9af069&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__